var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "cb-entries" } }, [
    _c(
      "div",
      {
        staticClass: "d-flex w-100",
        staticStyle: { "background-color": "#ffffff" },
      },
      [
        _c(
          "div",
          { staticClass: "side-menubar-wrapper" },
          [_c("SideMenuBar")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            { staticClass: "send-message-container" },
            [
              _vm.isError
                ? _c("a-alert", {
                    attrs: {
                      message: _vm.errorMessage,
                      type: "error",
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isSave
                ? _c("a-alert", {
                    attrs: {
                      message: _vm.saveMessage,
                      type: "success",
                      "show-icon": "",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "entries-container" }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "left" }, [
                _c(
                  "div",
                  {
                    staticClass: "title",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({ name: "chatbot-entities" })
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("chatbotv2.entities")) +
                        "\n                            "
                    ),
                    _c("md-icon", [_vm._v("chevron_right")]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "input-container" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.entitiesName,
                        expression: "entitiesName",
                      },
                    ],
                    attrs: { placeholder: _vm.$t("chatbotv2.entryName") },
                    domProps: { value: _vm.entitiesName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.entitiesName = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "right" }, [
                _c(
                  "div",
                  {
                    staticClass: "button-container",
                    on: { click: _vm.saveButtonClickHandler },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("chatbotv2.save")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-entries" }, [
              _c("div", { staticClass: "add-container" }, [
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.entries"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "add-entries-button",
                    on: { click: _vm.addEntryClickHandler },
                  },
                  [_c("md-icon", [_vm._v("add")])],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "entries-list" }, [
              _vm.entries.length < 1
                ? _c("div", { staticClass: "entries-list-empty-text" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("chatbotv2.youHaveNoEntries")) +
                        "\n                    "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entries.length > 0
                ? _c(
                    "div",
                    { staticClass: "list-wrapper" },
                    _vm._l(_vm.entries, function (entry, index) {
                      return _c("EntriesListItem", {
                        key: entry.value + "_" + index,
                        attrs: {
                          "initial-data": entry,
                          "other-entry-names": _vm.entries
                            .map(function (entry) {
                              return entry.value
                            })
                            .filter(function (x) {
                              return x !== entry.value
                            }),
                          open: _vm.openedEntryId === entry.value,
                          "on-opened": function () {
                            return (_vm.openedEntryId = entry.value)
                          },
                          "on-closed": function () {
                            return (_vm.openedEntryId = null)
                          },
                        },
                        on: {
                          "delete-entry": function ($event) {
                            return _vm.deleteEntry(index)
                          },
                          "update-entry": function (args) {
                            return _vm.updateEntry(args, index)
                          },
                          error: _vm.sendError,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }